// removed by extract-text-webpack-plugin
module.exports = {"content":"onfido-sdk-ui-crossDevice-Intro-content","stage":"onfido-sdk-ui-crossDevice-Intro-stage","stageIcon":"onfido-sdk-ui-crossDevice-Intro-stageIcon","stageIcon-sms":"onfido-sdk-ui-crossDevice-Intro-stageIcon-sms","stageIcon-take-photos":"onfido-sdk-ui-crossDevice-Intro-stageIcon-take-photos","stageIcon-take-selfie":"onfido-sdk-ui-crossDevice-Intro-stageIcon-take-selfie","stageIcon-return-computer":"onfido-sdk-ui-crossDevice-Intro-stageIcon-return-computer","stageMessage":"onfido-sdk-ui-crossDevice-Intro-stageMessage"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/Intro/style.css
// module id = 326
// module chunks = 1